import { render, staticRenderFns } from "./emailIntegration.vue?vue&type=template&id=481a0c51&scoped=true"
import script from "./emailIntegration.vue?vue&type=script&lang=js"
export * from "./emailIntegration.vue?vue&type=script&lang=js"
import style0 from "./emailIntegration.vue?vue&type=style&index=0&id=481a0c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a0c51",
  null
  
)

export default component.exports